require.register("registration/controllers/indexCtrl", function(exports, require, module){
  $0
  
});

